import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CTA, Icon, Text } from '../../../atoms';
import ButtonsBanner from '../ButtonsBanner';
import {
  ADD_SECTION,
  COURSE_TAB_SAVE,
  TUTOR_DISABLED_TAB_SET,
} from '../../../../app/redux/actions/tutors';
import routes from '../../../../routes';
import { CustomBox, Separator, Warning } from '../style';
import { ActivitiesContainer } from './style';
import SectionBox from '../../../atoms/SectionBox';
import ModalCreateQuiz from '../../../atoms/Modals/ModalCreateQuiz';
import ModalSelectScorm from '../../../atoms/Modals/ModalSelectScorm';
import InputLegend from '../../../atoms/InputLegend';
import CustomToggle from '../../../atoms/CustomToggle';
import ModalPreviewQuiz from '../../../atoms/Modals/ModalPreviewQuiz';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import theme from '../../../theme';

const Activities = ({
  mediaIsPhone,
  setDisabledTab,
  activeTab,
  sections,
  course,
  addSection,
  courseTabSave,
  isSupervisor,
}) => {
  const { editMode, activities: activitySlice } = course;
  const [selectedScormIds, setSelectedScormIds] = useState([]);
  const [sequential, setSequential] = useState(false);

  useEffect(() => {
    if (editMode) {
      setSequential(activitySlice?.sequential);
    } else {
      setSequential(false);
      setSelectedScormIds([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode]);

  const isValidActivities = (activities = []) => {
    let isValid = true;
    // at least 1 activity (supervisor), 2 activities (tutor)
    if (isSupervisor && activities?.length < 1) return false;
    if (!isSupervisor && activities?.length < 2) return false;
    activities.forEach((a) => {
      if (!a?.type) isValid = false;
      if (Object.keys(a?.data || {})?.length <= 0) isValid = false;
    });
    return isValid;
  };

  useEffect(() => {
    const sects = Object.values(sections || {});
    const activities = [];
    sects.forEach((s) => activities.push(...Object.values(s.activities)));

    const scormIds = (activities || [])
      .filter(
        (a) => a.type === 'activity_scorm' && (a?.data?.node_id || a?.data?.id)
      )
      .map((s) => s?.data?.node_id || s?.data?.id);
    setSelectedScormIds(scormIds);

    if (isValidActivities(activities)) {
      setDisabledTab({
        2: { completed: true },
        3: { disabled: false },
        4: { disabled: false },
      });
    } else {
      setDisabledTab({
        2: { completed: false },
        3: { disabled: true },
        4: { disabled: true },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sections]);

  useEffect(() => {
    return () => {
      if (activeTab === 2) {
        courseTabSave({
          tabName: 'activities',
          data: { sections, sequential },
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, sections, sequential]);

  return (
    <ActivitiesContainer>
      <div className={mediaIsPhone ? '' : 'd-flex sb title-wrapper'}>
        <Text type="b3" mb={mediaIsPhone ? 16 : 0}>
          Sezione dedicata all’aggiunta delle attività per il discente. Per
          procedere con la creazione del percorso formativo è necessario
          inserire almeno 2 attività.
        </Text>
        <CTA
          btnText="catalogo attività"
          type="tertiary"
          icon="link-external-02"
          onClick={() =>
            window.open(
              `${window.location.origin}${routes.scormList.path}`,
              '_blank'
            )
          }
        />
      </div>
      <Separator />
      <div className="d-flex g-48">
        <InputLegend
          label="Abilita attività propedeutiche nel percorso formativo"
          mb={0}
          tooltipKey="course_sequential"
          htmlFor="course-sequential"
        />
        <CustomToggle
          checked={sequential}
          onClick={() => setSequential(!sequential)}
          id="course-sequential"
        />
      </div>
      <Separator />
      {Object.keys(sections).map((k, i) => (
        <SectionBox key={`section-${i + 1}`} index={i + 1} sectionKey={k} />
      ))}
      <CustomBox>
        <CTA
          type="tertiary"
          btnText="AGGIUNGI ALTRA SEZIONE"
          icon="plus"
          onClick={addSection}
        />
      </CustomBox>
      {mediaIsPhone && (
        <>
          <Text type="b3" className="mt-5" mb={24} color={theme().colors.fail}>
            * campo obbligatorio
          </Text>
          <Warning>
            <Icon type="alert-circle" size={16} />
            <Text type="b4" className="warning d-flex align-start">
              Per procedere con la creazione del percorso formativo è necessario
              inserire almeno 2 attività in totale all’interno di una o più
              sezioni
            </Text>
          </Warning>
        </>
      )}
      <ButtonsBanner
        hasMandatoryFields
        warning="Per procedere con la creazione del percorso formativo è necessario inserire almeno 2 attività in totale all’interno di una o più sezioni"
      />
      <ModalCreateQuiz />
      <ModalPreviewQuiz />
      <ModalSelectScorm selectedScormIds={selectedScormIds} />
    </ActivitiesContainer>
  );
};

Activities.propTypes = {
  mediaIsPhone: PropTypes.bool,
  setDisabledTab: PropTypes.func,
  sections: PropTypes.object,
  activeTab: PropTypes.number,
  course: PropTypes.object,
  addSection: PropTypes.func,
  courseTabSave: PropTypes.func,
  isSupervisor: PropTypes.bool,
};

export default connect(
  (state) => {
    const { sections } = state.tutors.activities;
    const { activeTab, course } = state.tutors;
    const { isSupervisor } = state.user;
    return { sections, activeTab, course, isSupervisor };
  },
  (dispatch) => ({
    setDisabledTab: (tabs) => dispatch({ type: TUTOR_DISABLED_TAB_SET, tabs }),
    addSection: () => dispatch({ type: ADD_SECTION }),
    courseTabSave: ({ tabName, data }) =>
      dispatch({ type: COURSE_TAB_SAVE, tabName, data }),
  })
)(withMediaQueries(Activities));
